// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-2a2aaa8e],\n.fade-leave-active[data-v-2a2aaa8e] {\n  transition: all 0.5s ease;\n}\n.fade-enter-from[data-v-2a2aaa8e],\n.fade-leave-to[data-v-2a2aaa8e] {\n  transform: translateY(-20%);\n  opacity: 0;\n}\n.row_action[data-v-2a2aaa8e] {\n  cursor: pointer;\n}\n.row_action[data-v-2a2aaa8e]:hover {\n  background-color: #F8FAFC;\n}\n.row_action[data-v-2a2aaa8e] {\n  cursor: pointer;\n}\n.row_action[data-v-2a2aaa8e]:hover {\n  background-color: #EFF5FB;\n}", ""]);
// Exports
module.exports = exports;
